import { get } from 'lodash';

// local dependencies
import { HttpService } from 'core/modules/network-service';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';

/*************************************************************/

/**
 * @type {class}
 * @desc WebsiteIssues defines an HTTP service interface to send HTTP network requets.
 * @example
 * import { WebsiteIssuesService } from 'services/websiteIssues';
 *
 * // create service instance and send/cancel request
 * const websiteIssuesService = new WebsiteIssuesService();
 * const result = await websiteIssuesService.fetchData( '<user-id>' ); // fetch data
 * websiteIssuesService.cancel(); // cancel an active request
 */
export class WebsiteIssuesService extends HttpService {

    // submit form data
    async submitFormData( { url, data } ) {
        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data: data
            } );
    
            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE )
            };
        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE
            };
        }
    }

    // format error response
    _errorFormatter( errResponse ) {
        return errResponse; // some logic
    }
}
